/**
 * Utilidad única de RUT chileno (antes duplicada en SearchHour,
 * TakeHour y Register). Envuelve rut.js.
 */
import rutjs from 'rut.js'

/** Limpia puntos/guiones/espacios. */
export function cleanRut(raw) {
    return rutjs.clean(raw || '');
}

/** Valida el dígito verificador. */
export function isValidRut(raw) {
    const cleaned = cleanRut(raw);
    if (cleaned.length < 7) return false;
    return rutjs.validate(cleaned);
}

/** Formato de despliegue: 12.345.678-9 */
export function formatRut(raw) {
    return rutjs.format(cleanRut(raw));
}

/** Formato canónico de la API/BD: 12345678-9 (sin puntos, con guion). */
export function toApiFormat(raw) {
    const cleaned = cleanRut(raw);
    if (cleaned.length < 2) return cleaned;
    return cleaned.slice(0, -1) + '-' + cleaned.slice(-1);
}

export default { cleanRut, isValidRut, formatRut, toApiFormat };
